module.exports = __webpack_public_path__ + "static/media/cross-rounded.a9bd50d5.svg";